<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <div class="iscompanyQuit" v-if="form.auditStatus != 'pass' && form.auditStatus != 'refuse'">
            <img
              src="../../../assets/images/new/blueInfo.png"
              alt=""
            />{{ form.attendanceApplyDescription }}
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>基本信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">店员姓名</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">异常类型</div>
              <div class="itemNum">{{ form.abnormalTypeCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">打卡日期</div>
              <div class="itemNum">{{ formatDay(form.attendanceDate) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">打卡类型</div>
              <div class="itemNum">{{ form.attendanceTypeCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">打卡状态</div>
              <div class="itemNum">{{ form.punchStatusCn }}</div>
            </div>     

           <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">提交时间</div>
              <div class="itemNum">{{ formatDate(form.oxCtime) }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>审核流程</i></p>
           <div class="flex-row mlr24" v-for="item,index in form.flowAuditRecordList" :key="index">
            <div class="process-left">
              <div class="process-boxs">
                <div class="process-img">
                  <img :src="item.headImgUrl" alt="" v-if="item.headImgUrl">
                  <img src="../../../assets/images/staffJounary_headerImg.png" alt="" v-else>
                  <div class="audit-img">
                    <img src="../../../assets/images/audit_success.png" alt="" v-if="item.auditStatus == 'pass'">
                    <img src="../../../assets/images/audit_wait.png" alt="" v-else-if="item.auditStatus == 'wait'">
                    <img src="../../../assets/images/audit_refuse.png" alt="" v-else-if="item.auditStatus == 'refuse'">
                  </div>
                </div>
                <div class="process-vertical" v-if="form.flowAuditRecordList.length - index != 1"></div>
              </div>
            </div>
            <div class="ml16 w100b process-right">
              <div class="align-items color999 f12">
                <div>{{item.flowNodeName}}</div>
                <div>{{formatDate(item.auditTime)}}</div>
              </div>
              <div class="mt5 f16" :class="[form.flowAuditRecordList.length - index != 1 ? 'mb40':'mb20']">{{item.auditOpName}}<span v-if="item.auditStatus">（{{item.auditStatusCn}}）</span></div>
              <div class="process-refuse" v-if="item.auditStatus == 'refuse'">{{item.auditRemark}}</div>
            </div>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: {
    drawer,
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "异常处理",
      dialogHide: false,
      form: {},
      dialogHide: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.$api.get(this.$url.attendanceApply.get, {
            id: org.id
          }).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
            }
          }).catch(error => {});
      });
    },
    back () {
      this.addEditShow = false;
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.process-boxs {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.process-img {
  width: 40px;
  height: 40px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.audit-img {
  width: 14px;
  height: 14px;
  position: absolute;
  right: 0;
  bottom: 0;
    img {
    width: 100%;
    height: 100%;
  }
}
.process-vertical {
  width: 2px;
  height: 32px;
  margin: 4px 0;
  background: #E6E6E6;
}
.process-right {
  .process-refuse {
    padding: 12px;
    margin-top: 8px;
    color: #666;
    background: #F2F1F6;
    border-radius: 4px;
  }
}
</style>